import React from 'react';

const RANK_COLORS = ['#f59e0b', '#94a3b8', '#b45309', '#3B5BDB', '#10b981'];
const RANK_LABELS = ['🥇', '🥈', '🥉'];

export default function LeaderboardWidget({ data = [], onAgentClick }) {
  if (!data.length) {
    return (
      <div style={{ textAlign: 'center', padding: '24px 0', color: '#718096', fontSize: 13 }}>
        No agent data available
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1A202C', marginBottom: 12 }}>Top Agents</div>
      {data.slice(0, 8).map((agent, i) => {
        // Support both { name, points, tickets } and { label, value, total } shapes
        const name     = agent.name    || agent.label || '—';
        const resolved = agent.resolved ?? agent.value ?? 0;
        const tickets  = agent.tickets ?? agent.total ?? resolved;
        const pts      = agent.points   ?? agent.value ?? 0;
        const initials = name
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map(n => n[0])
          .join('')
          .toUpperCase() || '?';

        const canClick = typeof onAgentClick === 'function' && name !== '—';
        return (
          <div
            key={i}
            role={canClick ? 'button' : undefined}
            tabIndex={canClick ? 0 : undefined}
            onClick={canClick ? () => onAgentClick(name) : undefined}
            onKeyDown={canClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onAgentClick(name); } } : undefined}
            title={canClick ? `View tickets for ${name}` : undefined}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 6px',
              margin: '0 -6px',
              borderRadius: 8,
              borderBottom: i < data.slice(0, 8).length - 1 ? '1px solid #F0F2F5' : 'none',
              cursor: canClick ? 'pointer' : 'default',
              transition: 'background 0.15s',
            }}
            onMouseEnter={canClick ? (e) => { e.currentTarget.style.background = '#F0F4FF'; } : undefined}
            onMouseLeave={canClick ? (e) => { e.currentTarget.style.background = 'transparent'; } : undefined}
          >
            {/* Rank badge */}
            <div style={{
              width: 20, textAlign: 'center', fontSize: 14, flexShrink: 0,
              color: RANK_COLORS[i] || '#718096',
            }}>
              {i < 3 ? RANK_LABELS[i] : <span style={{ fontSize: 11, fontWeight: 700, color: '#718096' }}>#{i + 1}</span>}
            </div>

            {/* Avatar */}
            <div style={{
              width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
              background: `linear-gradient(135deg, ${RANK_COLORS[i] || '#3B5BDB'}, ${RANK_COLORS[(i + 1) % RANK_COLORS.length]})`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 800, color: '#fff',
            }}>
              {initials}
            </div>

            {/* Name + subtitle */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1A202C', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {name}
              </div>
              {agent.points !== undefined && (
                <div style={{ fontSize: 10.5, color: '#718096' }}>{pts} pts</div>
              )}
            </div>

            {/* Ticket count */}
            <div style={{ fontSize: 12, fontWeight: 800, color: '#3B5BDB', flexShrink: 0 }}>
              {tickets} <span style={{ fontSize: 10, fontWeight: 500, color: '#718096' }}>tickets</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
